<template>
  <div class='SearchInput01'>
    <div class="icon">
      <close-icon color="#000000" @click="$emit('CloseSearch')"/>
    </div>
    <div class="cont-input">
      <input ref="input" :value="SearchTerm01" @input="run" type="text">
    </div>
    <div class="icon">
      <search-icon01/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CloseIcon from '../Icons/CloseIcon.vue'
import SearchIcon01 from '@/components/Theme01/Icons/SearchIcon01'
export default {
  name: 'SearchInput01',
  components: { SearchIcon01, CloseIcon },
  data () {
    return {
      timeout: null
    }
  },
  computed: {
    ...mapGetters(['SearchTerm01'])
  },
  mounted () {
    this.$refs.input.focus()
    if(this.SearchTerm01.trim()) {
      this.search(this.SearchTerm01)
    }
  },
  methods: {
    ...mapActions(['SearchProd01', 'SetSearchTerm01']),
    run (e) {
      if(this.timeout !== null) {
        clearTimeout(this.timeout)
      }
      this.SetSearchTerm01(e.target.value)
      this.$emit('load', true)
      this.timeout = setTimeout(() => this.search(e.target.value), 800)
    },
    search (value) {
      this.$emit('load', true)
      this.SearchProd01(value)
        .then(() => this.$emit('load', false))
    }
  }
}
</script>

<style scoped>
.SearchInput01 {
  width: 100%;
  height: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon {
  width: 20%;
}

.cont-input {
  width: 80%;
}

input {
  width: 96%;
  padding: 2%;
  font-size: 18px;
  border: 0;
  border-bottom: thin solid #CCCCCC;
}

input:focus {
  outline: none;
}
</style>
